<div class="tab-card rounded-3 d-sm-flex p-2">
  <div
    class="tab-btn cursor-pointer rounded-3 py-2 px-3"
    [ngClass]="item?.active ? 'active' : ''"
    *ngFor="let item of tabItems"
    (click)="tabClicked(item)"
  >
    {{ item?.title }}
  </div>
</div>
